import { defineMessages } from 'react-intl-next';

const messages: {
	privacyPolicy: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	termsAndPolicy: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	termsOfService: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	termsAndPolicy: {
		id: 'growth.google-recaptcha.terms-and-policy.text',
		description: 'Text substitute for reCAPTCHA branding when badge is visibly hidden',
		defaultMessage:
			'This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.',
	},
	privacyPolicy: {
		id: 'growth.google-recaptcha.terms-and-policy.privacy-policy',
		description: 'Link text for the Google Privacy Policy page.',
		defaultMessage: 'Privacy Policy',
	},
	termsOfService: {
		id: 'growth.google-recaptcha.terms-and-policy.terms-of-service',
		description: 'Link text for the Google Terms of Service page.',
		defaultMessage: 'Terms of Service',
	},
});

export default messages;
